import type {ReactNode} from 'react'
import {Navigate, Outlet, useLocation} from 'react-router-dom'
import {useAuth} from '@/hooks/platform/use-auth'
import {conRetorno} from '@/lib/retorno-login'

/** `publicFallback` is a prop, not an import of the landing: dependency-cruiser only lets
 * `App.tsx` or a page import a page. */
export function ProtectedRoute({publicFallback}: {publicFallback?: ReactNode} = {}) {
  const {user, loading} = useAuth()
  const location = useLocation()

  if (loading) return null
  if (!user) {
    // KAI-353: la ruta pedida vuelve tras entrar; `conRetorno` la omite en la excepción de "/".
    const destino = conRetorno('/login', `${location.pathname}${location.search}`)
    return publicFallback ?? <Navigate to={destino} replace />
  }

  return <Outlet />
}
